export const PROMPT_TEMPLATE_TITLE_MAX_LENGTH = 200;
export const PROMPT_TEMPLATE_BODY_MAX_LENGTH = 10000;
